import React from 'react'
import { Helmet } from 'react-helmet';
import '../css/fitness.css';
/* Import the image to be shown on the page */
import schedule from '../images/Preschool.png';
import schedule2 from '../images/Preschool-Rates.png';
import button from '../images/button_enroll-now.png';

export default function Preschool() {
    return (
        <div className="Preschool-content">
            <Helmet>
                <title>In Motion Dance | PreSchool</title>
            </Helmet>
            <h1> In Motion Dance Studio PreSchool<br/></h1>
            {/* <h2 style={{ color: 'red' }}>PreSchool Start Date - Tuesday, August 20, 2024<br/></h2> */}
            <h5><br/>Updated: Monday, June 1, 2026</h5><br/>
            
            <img src={schedule} 
                alt="PreSchool Schedule for 2026"
                className="preschool-image"/>
            <img src={schedule2} alt='PreSchool Rates for 2026'/> 
            <br/><br/>
                <a href='enroll'>
                    <img src={button} alt='Enroll Now'/>
                </a>
            <br/><br/>
            <h4>Have questions? <a href="contact">Get in touch</a> — we’re happy to help you find the right fit!</h4>           
        </div>
    )
}